module.exports = require('./helpers/bundle-url').getBundleURL('47naU') + "logo.c51670a8.svg";